export function mapMailHavasToGescom(mailHavas) {
  return {
    to: mailHavas.To,
    cc: mailHavas.Cc || [],
    cci: mailHavas.Cci || [],
    objet: mailHavas.Objet,
    corps: mailHavas.Corps,
    replyTo: mailHavas.replyTo,
    from: mailHavas.replyTo,
    piecesJointes: [],
  };
}